import {ValueObject} from '@s-ui/domain'

export class GetTransactionParamsRequest extends ValueObject {
  /**
   * @param {Object} data
   * @param {String} data.adId
   * @param {String} data.buyerId
   * @param {String} data.sellerId
   **/
}
